// @flow
import api from './api';
import payment from './payment';
import phoneNumbers from './phoneNumber';
import priceCalendar from './priceCalendar';

export default [api, payment, priceCalendar, phoneNumbers];
